// Entitycore
import { PlanDetailsBuilder } from "../../legacyPlanner/plan/PlanDetailsBuilder";
/** Class to handle serialization/deserialization for plan details*/ export class PlanDetailsSerializationHandler {
    /** serialize to IGraphPlanDetailsResource */ toSerializable(key, value) {
        return value.toGraphSerializable();
    }
    /** build IPlanDetails from IGraphPlanDetailsResource */ fromSerializable(key, serializableValue) {
        return new PlanDetailsBuilder().fromGraphResource(serializableValue).build();
    }
}
